import { useEffect } from 'react';
// @ts-ignore rpc-client-utils is resolved by bend at build time
import { convertFieldValueAvroToJson } from 'rpc-client-utils';
import getLang from 'I18n/utils/getLang';
import { useGetListingDetailsV3LazyQuery } from '../../__generated__/chirp/com/hubspot/marketplace/listing/details/rpc/MarketplaceListingDetailsRpc.hooks';
import { useGetOfferingDetails } from 'integrations-reconnect-lib';
import { IntegrationProductType } from '../types/integrationProductType';
const getProductType = listingDetails => {
  const isMcpProduct = !!(listingDetails !== null && listingDetails !== void 0 && listingDetails.isMcpServer || listingDetails !== null && listingDetails !== void 0 && listingDetails.isMcpConnector);
  if ([IntegrationProductType.APP, IntegrationProductType.AGENT, IntegrationProductType.CONNECTOR, IntegrationProductType.WORKFLOW_TEMPLATE].includes(listingDetails === null || listingDetails === void 0 ? void 0 : listingDetails.productType) && !isMcpProduct) {
    return listingDetails === null || listingDetails === void 0 ? void 0 : listingDetails.productType;
  } else if ((listingDetails === null || listingDetails === void 0 ? void 0 : listingDetails.productType) === IntegrationProductType.APP && isMcpProduct) {
    return IntegrationProductType.CONNECTOR;
  }
  return IntegrationProductType.UNKNOWN;
};
const areListingDetailsProvided = listingDetails => {
  return !!(listingDetails !== null && listingDetails !== void 0 && listingDetails.listingId) && !!(listingDetails !== null && listingDetails !== void 0 && listingDetails.productType) && (listingDetails === null || listingDetails === void 0 ? void 0 : listingDetails.isMcpConnector) !== undefined && (listingDetails === null || listingDetails === void 0 ? void 0 : listingDetails.isMcpServer) !== undefined;
};
export const useListingDetails = ({
  appId,
  listingDetails: propsListingDetails,
  skip
}) => {
  const propsListingId = propsListingDetails === null || propsListingDetails === void 0 ? void 0 : propsListingDetails.listingId;

  /**
   * Fetch offering for `listingId` or use given from `props.listingDetails.listingId`
   */
  const {
    data: offering,
    loading: offeringLoading,
    error: offeringError
  } = useGetOfferingDetails({
    appId,
    skip: skip || !appId || !!propsListingId
  });
  const listingId = (offering === null || offering === void 0 ? void 0 : offering.listingId) || propsListingId || 0;

  /**
   * Fetch of listing details by listing ID  or use given from `props.listingDetails`
   */
  const [fetchDetails, {
    data: detailsData,
    loading: detailsLoading,
    error: detailsError
  }] = useGetListingDetailsV3LazyQuery();
  const listingDetails = detailsData !== null && detailsData !== void 0 && detailsData.listing ? convertFieldValueAvroToJson(detailsData.listing) : propsListingDetails || null;
  const hasListingDetailsProvided = areListingDetailsProvided(propsListingDetails);
  const hasDetailsRequestCompleted = !detailsLoading && !!(detailsError || detailsData !== null && detailsData !== void 0 && detailsData.listing);
  useEffect(() => {
    if (listingId && !hasDetailsRequestCompleted && !hasListingDetailsProvided && !skip) {
      fetchDetails({
        variables: {
          listingId,
          language: getLang()
        }
      });
    }
  }, [fetchDetails, hasDetailsRequestCompleted, listingId, hasListingDetailsProvided, skip]);
  return {
    data: Object.assign({}, listingDetails, {
      listingId,
      productType: getProductType(listingDetails),
      isMcpConnector: !!(listingDetails !== null && listingDetails !== void 0 && listingDetails.isMcpConnector),
      isMcpServer: !!(listingDetails !== null && listingDetails !== void 0 && listingDetails.isMcpServer)
    }),
    loading: offeringLoading || detailsLoading,
    error: offeringError || detailsError
  };
};